import UserRoleSpecificContent from './UserRoleSpecificContent.container';
import createShortcut from './utils/createShortcut';

// shortcut HOC for UserRoleSpecificContent
export const NonBOHSpecificContent = createShortcut({
  roles: 'back_of_house',
  validationType: 'exclude',
});

export default UserRoleSpecificContent;
